

































import { Component, Vue, Inject, Prop } from "vue-property-decorator";
import AbpBase from "../lib/abpbase";
import DatePicker from "./date-picker.vue";
@Component({ components: { DatePicker } })
export default class MeetCalendar extends AbpBase {
  date: string = "";
  month: string = "";
  index: number = 0;
  isCurrentMonth: boolean = true;

  setDate(item){
    console.log(item);
    this.date = item.currentMonth;
    this.month = item.month;
    this.index = item.index;
    this.isCurrentMonth = item.index == 0;
  }

  refresh(){
    (this.$refs.datepicker as any).freshCalendar(this.index);
  }
  currentMonth(){
    var date = new Date();
    if(this.index == 0) return;   
    this.month = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + "1";
    (this.$refs.datepicker as any).freshCalendar(0);
  }

  lastMonth() {
    var date = new Date(this.month);
    this.month = date.getFullYear() + "-" + date.getMonth() + "-" + "1";
    (this.$refs.datepicker as any).freshCalendar(--this.index);
  }

  async nextMonth() {
    var date = new Date(this.month);
    this.month = date.getFullYear() + "-" + (date.getMonth() + 2) + "-" + "1";
    await  (this.$refs.datepicker as any).freshCalendar(++this.index);
  }
  checkClickDay(item) {
    var date = new Date(this.month);
    item.title = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + item.index;
    item.date = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + (item.index+1);
    item.year = date.getFullYear();
    item.month = date.getMonth() + 1;
    item.day = item.index;
    this.$emit("day-click", item);
  }
}
